import { Field } from '../Field/field';
import { ModulesManagerService } from "../Module/modules-manager.service";

export class DateTimeField extends Field {
    
    constructor(manager :ModulesManagerService, Data= null){    
        super(manager, Data)
    }
        
    get Date(): string {
        return (new Date(this.Value))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_DATETIME_PICKER"))
    }

    get NormalizedDateFormat(): string {
        return (new Date(this.Value))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE"))
    }

    get HtmlValue(): string {
        return (new Date(this.Value))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_SHOW"))
    }

    set Date(value: any ) {
        if(value == null ||value == "") return;
        this.Value = (new Date(value))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_DATETIME_PICKER"))
    } 

    get Value(): any {
        return new Date(super.Value).getTime()
    }

    set Value(value){        
        super.Value =value 
    }

    /**
     * used for verifi is that field is valide for filter
     * @override
     * @param lookingFor string to search on field
     * @returns true if valide or false if not
     */
    public isFilterValid(lookingFor:string) :boolean {  
        return this.NormalizedDateFormat.includes(lookingFor)  
    }
}
